import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Button,
} from "reactstrap";

const FilterDropdown = ({ options, setState, state }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleCheckboxChange = (group, id) => {
    setState((prevState) => {
      const updatedGroup = prevState[group]?.includes(id)
        ? prevState[group].filter((item) => item !== id)
        : [...(prevState[group] || []), id];
      return {
        ...prevState,
        [group]: updatedGroup,
      };
    });
  };

  const handleClearAll = () => {
    setState((prevState) => {
      const clearedState = Object.entries(prevState).reduce((acc, [group]) => {
        acc[group] = [];
        return acc;
      }, {});

      return clearedState;
    });
  };

  return (
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle caret color="primary" className="w-100">
          Filter
        </DropdownToggle>

        <DropdownMenu style={{ padding: "15px", width: "300px" }}>
          <div style={{ maxHeight: "400px" }} className="overflow-auto">
            {Object.entries(options).map(([group, items]) => (
              <div key={group} className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <h6 className="mb-0 mr-2">{group}</h6>
                </div>

                {items.map((item) => {
                  const isChecked = state[group].includes(item.id); 
                  return (
                    <div key={item.id} className="ml-3">
                      <Label className="d-flex align-items-center">
                        <Input
                          type="checkbox"
                          style={{
                            appearance: "none",
                            WebkitAppearance: "none",
                            width: "1rem",
                            height: "1rem",
                            marginRight: "0.5rem",
                            borderRadius: "3px",
                            cursor: "pointer",
                            backgroundColor: isChecked ? "blue" : "transparent",
                            border: isChecked ? "1px solid blue" : "1px solid black",
                          }}
                          checked={isChecked}
                          onChange={() => handleCheckboxChange(group, item.id)}
                        />
                        {item.name}
                      </Label>
                    </div>
                  );
                })}

                {group !== Object.keys(options).slice(-1)[0] && (
                  <DropdownItem divider className="my-2" />
                )}
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-between mt-3">
            <Button color="secondary" size="sm" onClick={handleClearAll}>
              Clear All
            </Button>
          </div>
        </DropdownMenu>
      </Dropdown>
  );
};

export default FilterDropdown;
